"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFeather = require("react-feather");
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _loader = require("../loader");
var _FormContext = _interopRequireDefault(require("./FormContext"));
var _FormAutocomplete = _interopRequireDefault(require("./FormAutocomplete"));
var _Spinner, _CheckIcon;
const _excluded = ["value", "readOnly", "onFocus", "onBlur", "onSave"];
const FormEditableAutocomplete = _ref => {
  let {
      value,
      readOnly,
      onFocus,
      onBlur,
      onSave
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const {
    isFocus,
    onBlur: onInputBlur
  } = _react.default.useContext(_FormContext.default);
  const [saving, setSaving] = _react.default.useState(false);
  const [saved, setSaved] = _react.default.useState(false);
  const internalValueOptions = _react.default.useMemo(() => ({
    locked: isFocus
  }), [isFocus]);
  const [internalValue, setInternalValue] = (0, _arkReact.useInternalValueManager)(value ?? undefined, internalValueOptions);
  const lastValue = (0, _arkReact.usePrevious)(value ?? undefined);
  const savedHideTimeout = _react.default.useRef(null);

  // Unsubscribe to any event or async effect
  _react.default.useEffect(() => () => clearTimeout(savedHideTimeout?.current ?? undefined), [savedHideTimeout]);
  const handleInputChange = _react.default.useCallback(newValue => {
    setInternalValue(newValue);
    if (saved === true) setSaved(false);
  }, [saved, setInternalValue]);
  const handleInputFocus = _react.default.useCallback(event => {
    setSaved(false);
    if (savedHideTimeout.current !== null) {
      clearTimeout(savedHideTimeout.current);
      savedHideTimeout.current = null;
    }
    if ((0, _ark.isFunction)(onFocus)) onFocus(event);
  }, [savedHideTimeout, onFocus]);
  const handleInputBlur = _react.default.useCallback(async (newValue, event) => {
    let notifiedValue = lastValue ?? '';
    setInternalValue(newValue);
    if ((0, _ark.isString)(newValue) && (lastValue == null || newValue !== lastValue) && (0, _ark.isFunction)(onSave)) {
      setSaving(true);
      try {
        const savedValue = await onSave(newValue, event);
        if (savedValue !== undefined) {
          notifiedValue = savedValue;
          setSaved(true);
          savedHideTimeout.current = setTimeout(() => setSaved(false), 6000);
        }
      } catch {
        // Ignored
      }
      setSaving(false);
    }
    setInternalValue(notifiedValue);
    onInputBlur?.();
    onBlur?.(notifiedValue, event);
  }, [lastValue, onSave, onBlur, setInternalValue]);
  const icon = _react.default.useMemo(() => {
    if (saving) return _Spinner || (_Spinner = /*#__PURE__*/_react.default.createElement(_loader.Spinner, {
      className: "formEditableLoadingIcon"
    }));
    if (saved) return _CheckIcon || (_CheckIcon = /*#__PURE__*/_react.default.createElement(_reactFeather.Check, {
      className: "formEditableSavedIcon"
    }));
    return null;
  }, [saved, saving]);
  const internalReadOnly = _react.default.useMemo(() => readOnly || saving, [readOnly, saving]);
  return /*#__PURE__*/_react.default.createElement(_FormAutocomplete.default, (0, _extends2.default)({
    icon: icon,
    value: internalValue,
    readOnly: internalReadOnly,
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    managed: true
  }, props));
};
process.env.NODE_ENV !== "production" ? FormEditableAutocomplete.propTypes = {
  value: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  spellcheck: _propTypes.default.bool,
  autocapitalize: _propTypes.default.oneOf(['none', 'sentences', 'words', 'characters']),
  className: _propTypes.default.string,
  maxlength: _propTypes.default.number,
  readOnly: _propTypes.default.bool,
  state: _propTypes.default.oneOf(['error', 'warning', 'ok']),
  required: _propTypes.default.bool,
  onGetLabel: _propTypes.default.func,
  onGetOptions: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onSave: _propTypes.default.func
} : void 0;
FormEditableAutocomplete.defaultProps = {
  value: undefined,
  placeholder: undefined,
  spellcheck: undefined,
  autocapitalize: undefined,
  className: undefined,
  maxlength: undefined,
  readOnly: undefined,
  state: undefined,
  required: undefined,
  onGetLabel: undefined,
  onGetOptions: undefined,
  onFocus: undefined,
  onBlur: undefined,
  onSave: undefined
};
var _default = exports.default = FormEditableAutocomplete;